import React from 'react';
import classnames from 'classnames';
import useScreen from 'hooks/useScreen';
import { decideLaterItem } from 'components/consumer/PDP/PDPShopTabsBar/itemContent';

const DECIDE_LATER_TEXT =
  'Need a little extra time to decide? No worries, simply add your item to your cart with the “Buy Now, Decide Later” option selected. We’ll send you a free swatch kit with all of our upholstery options. Make your selection within 90 days by logging into your account and updating your order or reach out to customer service! Please note, if a fabric has not been chosen after 90 days, your order will be canceled and subject to a 10% cancellation fee.';
const PDPSelectUpholsteryDecideLater = () => {
  const { isMobile } = useScreen();

  return (
    <div className="mt-8 mx-0 mb-12" id={decideLaterItem.contentId}>
      <div className="text-[1.1875rem] tracking-[.0125rem] font-bold leading-[1.75rem] text-gray mb-4">
        Lock in your price now.
        <br />
        Choose your customizations within 90 days.
      </div>

      <div
        className={classnames(
          'text-sm text-gray',
          'PDPSelectUpholsteryDecideLater__content',
          {
            'ml-4': !isMobile,
            'ml-0': isMobile,
          }
        )}
      >
        {DECIDE_LATER_TEXT}
      </div>
    </div>
  );
};

export default PDPSelectUpholsteryDecideLater;
